import {
  PeriodChip,
  ReportPeriod,
  ReportType,
  TypeChip,
} from "@/components/common/report-chip";
import { Folder } from "lucide-react";

interface SelectedReportCardProps {
  name: string;
  type?: ReportType;
  period?: ReportPeriod;
  /** 현재 최신 버전 (예: "V14") */
  currentVersion: string;
}

// ============================================
// SelectedReportCard
// 버전 업데이트 대상(현재 보고서) 요약 카드. 표현만 담당.
// ============================================

export const SelectedReportCard = ({
  name,
  type,
  period,
  currentVersion,
}: SelectedReportCardProps) => (
  <div className="flex w-full items-center gap-3 rounded-lg bg-background-gray-alternative p-4">
    <div className="flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-blue-200">
      <Folder
        className="size-6 fill-blue-500 text-blue-500"
        strokeWidth={1.6}
      />
    </div>
    <div className="flex min-w-0 flex-1 flex-col gap-2">
      <div className="flex items-center gap-3">
        <div className="flex shrink-0 items-center gap-1">
          {type && <TypeChip type={type} size="large" />}
          {period && <PeriodChip period={period} size="large" />}
        </div>
        <span className="label-1-normal-medium truncate text-label-normal">
          {name}
        </span>
      </div>
      <span className="label-2-medium text-label-alternative">
        현재 버전: {currentVersion}
      </span>
    </div>
  </div>
);
